import { Switch, Group, useMantineColorScheme, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { useCallback } from 'react'
import ReactGA from 'react-ga4'
import { Sun, MoonStars } from 'tabler-icons-react'

export interface ThemeToggleProps {}

export const ThemeToggle: React.FC<ThemeToggleProps> = () => {
  const { colorScheme, toggleColorScheme } = useMantineColorScheme()
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.md})`)

  const handleThemeChange = useCallback(() => {
    console.log('Theme changed')
    ReactGA.event({
      category: 'Theme',
      action: 'Theme changed',
      label: colorScheme === 'dark' ? 'Light' : 'Dark',
    })
    toggleColorScheme()
  }, [colorScheme, toggleColorScheme])

  return (
    <Group position="center" my={30}>
      <Switch
        title="Toggle color theme"
        aria-label="Toggle color theme"
        checked={colorScheme === 'dark'}
        onChange={handleThemeChange}
        size={isMobile ? 'lg' : 'xl'}
        onLabel={<Sun color={theme.white} size="1.25rem" />}
        offLabel={<MoonStars color={theme.colors.gray[6]} size="1.25rem" />}
        sx={{
          '& .mantine-Switch-track': {
            cursor: 'pointer',
          },
        }}
      />
    </Group>
  )
}
